import React from "react";

const SearchResultsDropdown = ({
  isLoading,
  isError,
  results,
  handleResultClick,
  isProviderSearch,
}) => {
  return (
    <div
      className="absolute left-0 right-0 top-full mt-2 bg-white border border-gray-200 rounded-lg shadow-lg z-50"
      style={{ width: "210px" }}
    >
      {isLoading ? (
        <div className="p-4 text-gray-500">Loading...</div>
      ) : isError ? (
        <div className="p-4 text-red-500">Error fetching results</div>
      ) : results && results.length > 0 ? (
        <div className="max-h-60 overflow-y-auto">
          {results.map((provider) => (
            <div
              key={provider.rfi_id}
              className="flex items-center p-2 hover:bg-gray-100 cursor-pointer"
              onClick={() => handleResultClick(provider)}
            >
              {isProviderSearch && provider.logo ? (
                <img
                  src={provider.logo}
                  alt={provider.name}
                  className="w-10 h-10 mr-2 object-contain rounded"
                  style={{ width: "60px", height: "60px" }}
                />
              ) : null}

              <div>
                <div className="font-semibold text-gray-900">
                  {provider.name || provider.rfi_name}
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="p-4 text-gray-500">No results found</div>
      )}
    </div>
  );
};

export default SearchResultsDropdown;
